import { $, type Html, html, View } from 'rune-ts';
import klass from './Layout.module.scss';

export interface LayoutData {
  view?: View | Html;
}

export interface LayoutOption {
  klass?: string;
  fullwidth?: boolean;
  header?: View;
  footer?: View;
}

export class Layout extends View<LayoutData> {
  constructor(
    data: LayoutData,
    public option: LayoutOption = {},
  ) {
    super(data);
  }

  override template() {
    return html`<div class="${this.option.klass ?? ''} ${klass.layout} ">
      ${this.option.header ? html`<header class="${klass.header_container}">${this.option.header}</header>` : ''}
      <main class="${klass.body_container}">
        <div class="${klass.body}${this.option.fullwidth ? ' ' + klass.full_width : ''}">${this.data.view}</div>
      </main>
      ${this.option.footer ? html`<footer class="${klass.footer_container}">${this.option.footer}</footer>` : ''}
    </div> `;
  }

  transition(view: View) {
    this.data.view = view;
    const new_body$ = $.fromHtml(
      `<div class="${klass.body}${this.option.fullwidth ? ' ' + klass.full_width : ''} ${klass.fade_in}"></div>`,
    );
    new_body$.append(this.data.view.render());
    $(this.element())
      .find(`.${klass.body}`)
      ?.addClass(klass.fade_out)
      ?.closest(`.${klass.body_container}`)
      ?.append(new_body$);

    return new Promise<void>((resolve) => {
      new_body$.element().addEventListener('animationend', () => {
        $(this.element()).find(`.${klass.body}.${klass.fade_out}`)?.element().remove();
        $(this.element()).find(`.${klass.body}.${klass.fade_in}`)?.removeClass(klass.fade_in);
        resolve();
      });
    });
  }
}
